import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import "jspdf-autotable";


const AdmAttendanceEntry = () => {
  const todayDate = new Date().toISOString().split("T")[0];
  const [visitorData, setVisitorData] = useState([]);
  const [name, setName] = useState("");
  const [whomToMeet, setWhomToMeet] = useState("");
  const [visitorClass, setVisitorClass] = useState("");
  const [section, setSection] = useState("");
  const [phone, setPhone] = useState("");
  const [fromDate, setFromDate] = useState(todayDate);
  const [toDate, setToDate] = useState(todayDate);

  const sanitizeLeadingSpaces = (value) => value.replace(/^\s+/, "");

  const handleTextFilterChange = (setter) => (e) => {
    setter(sanitizeLeadingSpaces(e.target.value));
  };

  const handleTextFilterPaste = (setter) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    setter(sanitizeLeadingSpaces(pastedText));
  };
  

  // Pagination states
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  // Items per page
  const itemsPerPage = 10;

  // Update pagination whenever visitorData or itemOffset changes
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(visitorData.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(visitorData.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, visitorData]);

  // Handle page click
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % visitorData.length;
    setItemOffset(newOffset);
  };
  const navigate = useNavigate();

  const handleClear = () => {
    setName("");
    setWhomToMeet("");
    setVisitorClass("");
    setSection("");
    setPhone("");
    setFromDate(todayDate);
    setToDate(todayDate);
    setVisitorData([]); // Clear the table data
  };

  const handleNewClick = () => {
    navigate("/admin/new-visitor");
  };

  const fetchVisitors = async (filters = {}) => {
    const academicSessionId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    const params = new URLSearchParams({
      academic_year_id: academicSessionId,
      org_id: orgId,
      branch_id: branchId,
      ...filters,
    });

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}VISITORS/list/?${params.toString()}`
      );
      const result = await response.json();
      if (result.message === "success") {
        setVisitorData(result.data || []);
      }
    } catch (error) {
      console.error("Error fetching visitor data:", error);
    }
  };

  useEffect(() => {
    fetchVisitors(); // Load table data on page open
  }, []);

  const handleSearch = () => {
    const filters = {};
    if (name) filters.visitor_name = name;
    if (whomToMeet) filters.whomToVisit = whomToMeet;
    if (visitorClass) filters.visitor_class = visitorClass;
    if (section) filters.section = section;
    if (phone) filters.phone = phone;
    if (fromDate) filters.from_date = fromDate;
    if (toDate) filters.to_date = toDate;

    fetchVisitors(filters);
  };

  // Already imported
 const handleMarkOut = async (visitorId) => {
   // Get local system date + time in YYYY-MM-DD HH:mm:ss format
   const now = new Date();
   const currentTime = `${now.getFullYear()}-${String(
     now.getMonth() + 1
   ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
     now.getHours()
   ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
     now.getSeconds()
   ).padStart(2, "0")}`;

   try {
     const response = await fetch(
       `${ApiUrl.apiurl}VISITORS/update/${visitorId}/`,
       {
         method: "PUT",
         headers: {
           "Content-Type": "application/json",
         },
         body: JSON.stringify({
           outtime: currentTime,
         }),
       }
     );

     if (response.ok) {
       await response.json();

       // Optional: Update UI immediately
       setVisitorData((prevData) =>
         prevData.map((visitor) =>
           visitor.visitor_id === visitorId
             ? { ...visitor, outTime: currentTime }
             : visitor
         )
       );

       // Refresh data from backend
       fetchVisitors();
     } else {
       const errorData = await response.json();
       console.error("Failed to mark out:", errorData);
     }
   } catch (error) {
     console.error("Error while marking out:", error);
   }
 };

  const handleDelete = async (visitorId) => {
    if (!window.confirm("Are you sure you want to delete this visitor record?")) {
      return;
    }

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}VISITORS/delete/${visitorId}/`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Visitor deleted:", data);
        
        // Remove the deleted visitor from state
        setVisitorData((prevData) =>
          prevData.filter((visitor) => visitor.visitor_id !== visitorId)
        );
        
        alert("Visitor record deleted successfully!");
      } else {
        const errorData = await response.json();
        console.error("Failed to delete:", errorData);
        alert("Failed to delete visitor record.");
      }
    } catch (error) {
      console.error("Error while deleting visitor:", error);
      alert("Error deleting visitor record.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                SEARCH VISITORS
              </p>
              <div className="row mb-3 mt-3">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleNewClick}
                  >
                    New visitors
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={handleSearch}
                    style={{
                      width: "150px",
                    }}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* feild data */}
              <div className="row p-2">
                <div
                  className="col-12 p-2"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    background: "white",
                  }}
                >
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="name" className="form-label">
                          Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="name"
                            className="form-control detail"
                            placeholder="Enter Name"
                            value={name}
                            onChange={handleTextFilterChange(setName)}
                            onPaste={handleTextFilterPaste(setName)}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="whom-to-meet" className="form-label">
                          Whom To Meet
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="whom-to-meet"
                            className="form-control detail"
                            placeholder="Enter whom to meet"
                            value={whomToMeet}
                            onChange={handleTextFilterChange(setWhomToMeet)}
                            onPaste={handleTextFilterPaste(setWhomToMeet)}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="phone" className="form-label">
                          phone
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="phone-number"
                            className="form-control detail"
                            placeholder="Enter phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="visitor-class" className="form-label">
                          Class
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="visitor-class"
                            className="form-control detail"
                            placeholder="Enter class"
                            value={visitorClass}
                            onChange={handleTextFilterChange(setVisitorClass)}
                            onPaste={handleTextFilterPaste(setVisitorClass)}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="visitor-section" className="form-label">
                          Section
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="visitor-section"
                            className="form-control detail"
                            placeholder="Enter section"
                            value={section}
                            onChange={handleTextFilterChange(setSection)}
                            onPaste={handleTextFilterPaste(setSection)}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="from-date" className="form-label">
                          From Date
                        </label>
                        <input
                          type="date"
                          id="from-date"
                          className="form-control detail"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="To-date" className="form-label">
                          To Date
                        </label>
                        <input
                          type="date"
                          id="To-date"
                          className="form-control detail"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table data */}
              <div className="row mt-3">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table table-bordered ">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Name</th>
                          <th>Purpose Of Visit</th>
                          <th>Whom To Visit</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Address</th>
                          <th>Vehicle No.</th>
                          <th>Visit Date </th>
                          <th>In Time</th>
                          <th>Photo</th>
                          <th>Out Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td
                              colSpan="15"
                              className="text-center text-danger"
                            >
                              No record found
                            </td>
                          </tr>
                        ) : (
                          currentItems.map((visitor, index) => (
                            <tr key={visitor.visitor_id}>
                              <td>{itemOffset + index + 1}</td>
                              <td>{visitor.visitor_name}</td>
                              <td>{visitor.purpose_of_visit}</td>
                              <td>{visitor.whomToVisit}</td>
                              <td>{visitor.class || visitor.visitor_class}</td>
                              <td>{visitor.section}</td>
                              <td>{visitor.phone}</td>
                              <td>{visitor.email}</td>
                              <td>{visitor.address}</td>
                              <td>{visitor.VehicleNo}</td>
                              <td>{visitor.visitDate}</td>
                              <td>{visitor.InTime}</td>
                              <td>
                                {visitor.image ? (
                                  <img
                                    src={visitor.image}
                                    alt={visitor.visitor_name}
                                    style={{
                                      width: "60px",
                                      height: "60px",
                                      objectFit: "cover",
                                      borderRadius: "6px",
                                    }}
                                  />
                                ) : (
                                  "No Image"
                                )}
                              </td>
                              <td>
                                {visitor.outTime ? (
                                  visitor.outTime
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    onClick={() =>
                                      handleMarkOut(visitor.visitor_id)
                                    }
                                  >
                                    Mark Out
                                  </button>
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(visitor.visitor_id)}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  {visitorData.length > itemsPerPage && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;

